<div class="outer-container">

    <div id="file-upload" style="margin-bottom: 20px">
        <h3>{{ 'UploadQueue' | translate }}</h3>
        <div>
            <table class="table" *ngIf="filesView" aria-label="file upload" [ngClass]="{'popup-custom-class': externalPage !== 'incoming'}">
                <thead>
                    <tr>
                        <th>{{ 'Name' | translate }}</th>
                        <th>{{ 'LesionSize' | translate}}</th>
                        <th>{{ 'Progress' | translate }}</th>
                        <th>{{ 'Status' | translate}}</th>
                        <th>{{ 'Actions' | translate}}</th>
                    </tr>
                </thead>
                <tbody [ngClass]="{'fixed-height': filesView.length > 3 && externalPage !== 'incoming'}">
                    <tr file-loaded *ngFor="let file of filesView; let i=index"
                        [fileView]="file"
                        [loadSuccess]="loadSuccess"
                        [disableAllButtonsRow]="formData?.invalid"
                        (rowFileClicked)="rowClicked(i, $event)">
                    </tr>
                </tbody>
            </table>
        </div>
        
        <div>
            <div>
                <p class="queue-progress">{{ 'QueueProgress' | translate }} : {{filesToUpload}}</p>
                <div class="progress">
                    <mat-progress-bar class="progress-bar"
                                      *ngIf="uploadProgress"
                                      mode="determinate"
                                      [value]="uploadProgress">

                    </mat-progress-bar>
                </div>
            </div>
            <div class="btn-all-container">
                <button type="button" class="btn btn-primary btn-s" [disabled]="formData?.invalid || !multipleActionAllowed()"
                        (click)="uploadAll()">
                    <span class="glyphicon glyphicon-upload"></span> {{ 'UploadAll' | translate }}
                </button>
                <button type="button" class="btn btn-primary btn-s" [disabled]="formData?.invalid || !multipleActionAllowed()"
                        (click)="deleteAll()">
                    <span class="glyphicon glyphicon-trash"></span> {{ 'RemoveAll' | translate }}
                </button>
            </div>

        </div>
    </div>
</div>
